import { OWAConnectedAccount } from 'owa-accounts-store';

export default function getAccountAddressForMergedView(account: OWAConnectedAccount): string {
    return account.accountProviderType == 'Google' || account.accountProviderType == 'ICloud'
        ? account.anchorMailbox
        : account.userIdentity;
}
